import { BaseApi } from './base.api.js';

export class UserTrainingApi extends BaseApi {
    constructor(client) {
        super(client, '/user-training');
    }
}
